import { LAUNCHER_ITEMS } from './launcherItems';

export const DEFAULT_TOP_MENU = Object.freeze(['dashboard','agreements','inward','storage','outward','finance','reports']);
export const DEFAULT_DOCK_MENU = Object.freeze(['growers','gate','inspection','crates','settings']);

export const DEFAULT_NAVIGATION_SETTINGS = Object.freeze({
  enabled: true,
  showSidebar: false,
  showTopMenu: true,
  showDock: true,
  topMenuItems: DEFAULT_TOP_MENU,
  dockItems: DEFAULT_DOCK_MENU,
  customLabels: {},
  showLabelsInDock: false,
  dockMagnification: 1,
  dockNeighborMagnification: .45,
  notificationBounce: true,
  userCustomizedLayout: false,
});

const validKeys = new Set(Object.keys(LAUNCHER_ITEMS));
const cleanItems = (value, fallback) => {
  const rows = Array.isArray(value) ? value.filter((key) => validKeys.has(key)) : [];
  return Array.from(new Set(rows.length ? rows : fallback));
};

export const normalizeNavigationSettings = (value = {}) => ({
  ...DEFAULT_NAVIGATION_SETTINGS,
  ...(value || {}),
  enabled: value?.enabled !== false,
  showSidebar: value?.showSidebar === true,
  showTopMenu: value?.showTopMenu !== false,
  showDock: value?.showDock !== false,
  topMenuItems: cleanItems(value?.topMenuItems, DEFAULT_TOP_MENU),
  dockItems: cleanItems(value?.dockItems, DEFAULT_DOCK_MENU),
  customLabels: value?.customLabels && typeof value.customLabels === 'object' ? value.customLabels : {},
  userCustomizedLayout: value?.userCustomizedLayout === true,
  dockMagnification: Math.max(.5, Math.min(1.6, Number(value?.dockMagnification ?? 1) || 1)),
  dockNeighborMagnification: Math.max(0, Math.min(1, Number(value?.dockNeighborMagnification ?? .45) || 0)),
});
